/* src/app/warehousing/partials/stock-label/stock-label.component.scss */
.stockLabel {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 90mm;
  height: 45mm;
  padding: 3mm;
  border: 1px solid #333;
  background-color: white;
  overflow: hidden;
  page-break-inside: avoid;
  break-inside: avoid;
}
.stockLabelText {
  display: flex;
  flex-flow: column nowrap;
  margin-left: 3mm;
  overflow: hidden;
}
.stockLabelText strong {
  font-size: 1.5rem;
  line-height: 1.2;
}
.stockLabelText span {
  font-size: 1.1rem;
}
.stockLabelText small {
  color: #555;
}
.stockLabel.zebra {
  box-sizing: border-box;
  padding: 2mm;
  margin-bottom: 4mm;
  color: black;
}
.stockLabel.zebra.portrait {
  flex-flow: column nowrap;
  justify-content: flex-start;
}
.stockLabelQr {
  flex: 0 0 auto;
}
.stockLabelQr ::ng-deep canvas,
.stockLabelQr ::ng-deep img {
  display: block;
  width: 100% !important;
  height: 100% !important;
}
.stockLabel.zebra .stockLabelText {
  min-width: 0;
  line-height: 1.15;
  overflow-wrap: anywhere;
}
.stockLabel.zebra.portrait .stockLabelText {
  margin-left: 0;
  margin-top: 2mm;
  align-items: center;
  text-align: center;
  width: 100%;
}
.stockLabel.zebra .stockLabelText strong,
.stockLabel.zebra .stockLabelText span {
  line-height: 1.15;
}
.stockLabel.zebra .stockLabelText small {
  color: black;
}
/*# sourceMappingURL=stock-label.component.css.map */
